import { ArticleContainer } from '@3d-scene/model3d/article-container';
import { ArticleVO } from '@article/model/vo/article.vo';

export class BridgeArticlePostParseProcessor {

  public static process(container: ArticleContainer, articleVO: ArticleVO): void {
    if (this.canModify3DArticleGeometry() && container.articleObject3DDataShared) {
      throw new Error('Modifying a shared article geometry is not allowed!');
    }
  }

  public static canModify3DArticleGeometry(): boolean {
    // geometry of wire-bridge will be changed/modified once article will be connected, so this method still has to return true
    // corresponding functionality moved to ResizeWireBridgeProcessor
    return true;
  }
}
